import * as React from 'react';

import { BaseComponent } from './BaseComponent';
import { SelectBoxOption } from '../stores/SelectBoxStore';
import { DesktopSelect } from './DesktopSelect';
import { SelectBoxActions } from '../actions/SelectBoxActions';

interface SelectionProps {
    borderOverride?: boolean;
}

interface SelectionState {
    value: string | number | boolean | null;
    visible: boolean;
    enabled: boolean;
}

export class SelectionBase extends BaseComponent<SelectionProps, SelectionState> {
    protected showValueInApp: boolean = false;
    protected id: string = 'selection-base';

    public componentWillMount(): void {
        this.setState({
            value: null,
            visible: true,
            enabled: true
        });
    }

    public render(): JSX.Element | null {
        const options: Array<SelectBoxOption> = this.options();
        if (this.state.visible && options.length > 1 && this.state.enabled) {
            return (
                <DesktopSelect title={this.getLabel()} options={this.options()} id={this.id} value={this.state.value}/>
            );
        }

        return null;
    }

    protected getLabel(): string {
        return 'SelectionBase';
    }

    protected inAppClick = (): void => {
        SelectBoxActions.showSelectBox({
            options: this.options(),
            title: this.getLabel(),
            sender: this.id,
            value: this.state.value,
            asOverlay: false
        });
    };

    protected options(): Array<SelectBoxOption> {
        return [];
    }

    protected valueSpan(): JSX.Element | null  {
        if (!this.showValueInApp) {
            return null;
        }
        const filteredOptions: Array<SelectBoxOption> = this.options().filter((option) => {
            return (option.key === this.state.value);
        });
        if (filteredOptions.length) {
            return <span className="selected-value">{filteredOptions[0].name}</span>;
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SelectionBase.tsx